import Stack from "../structs/Stack";
import EventLog from "../../../logger/events";
import { UPDATE_PAYMENT_DATA } from "../actions";
// import ActionTypes from "redux/src/utils/actionTypes";
import { isPlainObject, withProperties } from "../../../utils";

const hasProperty = Function.prototype.call.bind(Object.prototype.hasOwnProperty);

export default function __factory__(fields) {
  let timer, withUpdates = false;
  const { $inputs, dispatch } = this;

  const REDUCERS = Object.create(null);
  const keyMappings = Object.create(null);
  const inputFieldsFocusStack = new Stack();

  let currentInputs, inputFields, inputFieldsCount;

  const CURRENT_INPUTS = withProperties(Object.create(null), (
    [].concat(fields).reduce((reducersObject, key) => {
      let [inputKey, localKey = inputKey] = String(key).split('::');

      if (hasProperty($inputs, inputKey)) {
        localKey = localKey.trim() || inputKey;
        reducersObject[localKey] = $inputs[inputKey];

        if (hasProperty(keyMappings, localKey)) {
          throw new Error(`Duplicate local view input key(\`${localKey}\`) not allowed.`);
        }
        
        withProperties(keyMappings, { [localKey]: inputKey });

        $inputs.$subscribe(inputKey, __inputSubscription__);
      }

      return reducersObject;
    }, {})
  ), true);

  const INPUT_FIELDS = Object.keys(CURRENT_INPUTS);

  __updateAvailableInputs__();

  withProperties(REDUCERS, {
    inputs(state = __getInputFields__(), action) {
      switch (action.type) {
        case UPDATE_PAYMENT_DATA: return __getInputFields__();
        // case ActionTypes.REPLACE: return __getInputFields__();
        default: return state;
      }
    }
  });

  function __updateAvailableInputs__() {
    const availableInputs = INPUT_FIELDS.reduce((available, field) => {
      const mappedInputField = keyMappings[field];

      $inputs.$available(mappedInputField) && (
        available = {
          ...available,
          [field]: CURRENT_INPUTS[field]
        }
      );

      return available;
    }, {});

    currentInputs = withProperties(Object.create(null), { ...availableInputs }, true);
    inputFields = Object.keys(currentInputs);
    inputFieldsCount = inputFields.length;
  }

  function __inputSubscription__() {
    timer && clearTimeout(timer);
    timer = setTimeout(__flushInputUpdates__, 0);
    !withUpdates && (withUpdates = true);
  }

  function __flushInputUpdates__() {
    dispatch({ type: UPDATE_PAYMENT_DATA });
    timer && clearTimeout(timer);
    timer = undefined;
  }

  function __getInputFields__() {
    if (withUpdates) {
      INPUT_FIELDS.forEach(field => {
        const mappedInputField = keyMappings[field];

        if (CURRENT_INPUTS[field] !== $inputs[mappedInputField]) {
          CURRENT_INPUTS[field] = $inputs[mappedInputField];
        }
      });

      __updateAvailableInputs__();
      withUpdates = false;
    }

    return currentInputs;
  }

  function __setInputFields__(inputs) {
    inputs = isPlainObject(inputs)
      ? inputs
      : inputFieldsCount === 1
        ? { [inputFields[0]]: inputs }
        : null;

    if (isPlainObject(inputs)) {
      inputFields.forEach(field => {
        if (hasProperty(inputs, field)) {
          try {
            const mappedInputField = keyMappings[field];
            $inputs.$update(mappedInputField, inputs[field]);
          } catch (e) {}
        }
      });
    }
  }

  return Object.defineProperties(REDUCERS, {
    $focusin: {
      value(field) {
        const mappedInputField = keyMappings[field];

        if (inputFieldsFocusStack.empty && $inputs.$available(mappedInputField)) {
          inputFieldsFocusStack.push(mappedInputField);
          const input = currentInputs[field];
          
          if (input.type === 'PLAIN') {
            EventLog.startedInput(field);
          }
        }
      }
    },

    $focusout: {
      value(field) {
        const mappedInputField = keyMappings[field];

        if (
          !inputFieldsFocusStack.empty &&
          $inputs.$available(mappedInputField) &&
          inputFieldsFocusStack.peek === mappedInputField
        ) {
          inputFieldsFocusStack.pop(mappedInputField);
          const input = currentInputs[field];

          if (input.type === 'PLAIN') {
            EventLog.stoppedInput(field);
          } else if (input.type === 'SELECTION') {
            EventLog.selectedOption(field, input.value)
          }
        }
      }
    },

    $loggingCompleted: {
      get() { return inputFieldsFocusStack.empty }
    },

    $update: {
      value: __setInputFields__
    },

    $unsubscribe: {
      value() {
        INPUT_FIELDS.forEach(field => {
          const mappedInputField = keyMappings[field];
          $inputs.$unsubscribe(mappedInputField, __inputSubscription__);
        });
      }
    }
  });
}
